import React from 'react';

// Campo de importe: se escribe con separador de miles (1.250.000) y devuelve el número pelado.
const soloDigitos = (v) => String(v ?? '').replace(/[^\d]/g, '');
const conPuntos = (v) => {
  const d = soloDigitos(v);
  return d ? Number(d).toLocaleString('es-AR') : '';
};

export default function InputMonto({ value, onChange, placeholder = '0', ...props }) {
  return (
    <input
      {...props}
      type="text"
      inputMode="numeric"
      value={conPuntos(value)}
      placeholder={placeholder}
      onChange={(e) => {
        const limpio = soloDigitos(e.target.value);
        onChange(limpio === '' ? '' : Number(limpio));
      }}
    />
  );
}

export { conPuntos };
